
import { setToken, removeToken } from '@/helpers/auth'

const state = {
  token: '',
  accessToken: '',
  accessTokenTimeout: 0,
  roleList: [],
  customerConditionType: '', // SALES_ROLE  CONSULATANT_ROLE  OTHER_ROLE
  accountInfo: {},
  storesList: [],
  manageArea: [],
  programTypeList: [],
  agreements: []
}

const mutations = {
  SET_ACCESS_TOKEN: (state, data) => {
    const { token, accessToken, accessTokenTimeout } = data
    state.token = token
    state.accessToken = accessToken
    state.accessTokenTimeout = accessTokenTimeout
  },
  SET_ROLE: (state, data) => {
    state.roleList = data
  },
  SET_ROLE_TYPE: (state, data) => {
    state.customerConditionType = data
  },
  SET_ACCOUNT_INFO: (state, data) => {
    state.accountInfo = { ...state.accountInfo, ...data }
  },
  SET_STORES_LIST: (state, data) => {
    state.storesList = data
  },
  SET_MANAGE_AREA: (state, data) => {
    state.manageArea = data
  },
  SET_PROGRAM_TYPE_LIST: (state, data) => {
    state.programTypeList = data
  },
  SET_AGREEMENTS: (state, data) => {
    state.agreements = data
  }
}

const actions = {
  SET_ACCESS_TOKEN({ commit }, data) {
    commit('SET_ACCESS_TOKEN', data)
  },
  REMOVE_TOKEN({ commit }) {
    return new Promise(resolve => {
      commit('SET_ACCESS_TOKEN', {
        token: process.env.VUE_APP_TOKEN,
        accessToken: '',
        accessTokenTimeout: ''
      })
      // 重置token
      removeToken()
      // 设置登录默认token
      setToken(process.env.VUE_APP_TOKEN)

      resolve()
    })
  },
  SET_ROLE({ commit }, data) {
    commit('SET_ROLE', data)
  },
  SET_ROLE_TYPE({ commit }, data) {
    commit('SET_ROLE_TYPE', data)
  },
  SET_ACCOUNT_INFO({ commit }, data) {
    commit('SET_ACCOUNT_INFO', data)
  },
  SET_STORES_LIST({ commit }, data) {
    commit('SET_STORES_LIST', data)
  },
  SET_MANAGE_AREA({ commit }, data) {
    commit('SET_MANAGE_AREA', data)
  },
  SET_PROGRAM_TYPE_LIST({ commit }, data) {
    commit('SET_PROGRAM_TYPE_LIST', data)
  },
  SET_AGREEMENTS({ commit }, data) {
    commit('SET_AGREEMENTS', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
